import type { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import PatientIdentityContext from "src/contexts/data/PatientIdentityContext";
import type { GetPatientIdentityByIdResponse } from "src/api/Tmd.dtos";
import usePatientIdentityById from "src/hooks/data/load/usePatientIdentityById";
import type { SWRConfiguration } from "swr";

interface IPatientProviderProps extends PropsWithChildren {
    id?: number;
    configuration?: SWRConfiguration<
        GetPatientIdentityByIdResponse,
        GetPatientIdentityByIdResponse
    >;
}

const PatientIdentityProvider: FC<IPatientProviderProps> = ({
    children,
    id,
    configuration,
}) => {
    const context = usePatientIdentityById(id, configuration);

    return (
        <PatientIdentityContext.Provider value={context}>
            {children}
        </PatientIdentityContext.Provider>
    );
};

export const RoutePatientIdentityProvider: FC<PropsWithChildren> = ({ children }) => {
    const { patientId } = useParams<{ patientId: string }>();
    const id = patientId ? parseInt(patientId, 10) : undefined;

    return <PatientIdentityProvider id={id}>{children}</PatientIdentityProvider>;
};

export default PatientIdentityProvider;
